import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const SONUC_RENK: Record<string, string> = { 'Uygun': '#52c41a', 'Uygun Degil': '#ff4d4f', 'Sartli Kabul': '#ff9500' };

@Component({
  selector: 'kalite-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" [style.--sk-accent]="sonucRenk()">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('urunAdi') || 'Isimsiz' }}</div>
        @if (deger('partNo')) { <div class="sk-alt">{{ deger('partNo') }}</div> }
        @if (deger('olcuDeger')) {
          <div class="sk-alt">{{ deger('olcuDeger') }} @if (deger('tolerans')) { &plusmn;{{ deger('tolerans') }} }</div>
        }
      </div>
      <div class="sk-sag">
        @if (deger('sonuc')) { <span class="sk-badge" [style.background]="sonucRenk()">{{ deger('sonuc') }}</span> }
      </div>
    </div>
  `,
})
export class KaliteKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  sonucRenk = computed(() => SONUC_RENK[this.deger('sonuc')] || '#ff9500');
}
